import React, { useState, useRef } from "react";
import { IonApp, IonCard, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/Olympiad/ClassOne";
import Header from "../../pages/Header";
import Footer from "../../pages/Footer";

const IMO: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    document.title = "Mamas Guidance - Olympiad - Class One"

    return (
        <IonContent>
            <Header />
            <IonCard className='privacy-policy-section'>
                <h1 className='text-center font-50'>IMO</h1>
                <p className="mt-5">
                    <strong>IMO (International Mathematics Olympiad)</strong> is a competitive exam organized by
                    &nbsp;<strong>SOF (Science Olympiad Foundation)</strong> for students from Class 1 onwards.
                    It aims to develop <em>mathematical reasoning, logical thinking,</em> and
                    <em>problem-solving skills</em> in children.
                    The exam includes a variety of engaging and age-appropriate math questions designed to go
                    beyond the regular school curriculum.
                </p>
                <div className='mt-5'>
                    <div className="classes-grid">
                        <div className="olympiad-card imo">
                            <h3>Class One</h3>
                            <p>It covers number sense, basic addition and subtraction, shapes, patterns, time, money, measurement.</p>
                            <a href="/olympiad-classone/imo">Start Now</a>
                        </div>
                        <div className="olympiad-card nso">
                            <h3>Class Two</h3>
                            <p>It covers number sense, addition, subtraction, multiplication, division, time, money, measurement, shapes, patterns, data handling.</p>
                            <a href="/olympiad-classtwo/imo">Start Now</a>
                        </div>
                        <div className="olympiad-card nso">
                            <h3>Class Three</h3>
                            <p>It covers numbers, addition, subtraction, multiplication, division, fractions, measurement, time, money, geometry & maps, data handling.</p>
                            <a href="/olympiad-classthree/imo">Start Now</a>
                        </div>
                    </div>
                </div>
            </IonCard>
            <Footer />
        </IonContent>
    );
};
export default IMO;